// extracted by mini-css-extract-plugin
export default {"chat":"TutorLessonRoom_chat__wlkF9"};